<ui-title [title]="'Approver Overrides'"></ui-title>

<ui-alert
		*ngIf="modalAlert.display"
		[title]="modalAlert.title"
		[text]="modalAlert.text"
		(onAction)="modalAlert.cb($event)"
	></ui-alert>
<ui-loading [loading]="mapping.loading"></ui-loading>
<ui-table [chunker]="mapping.chunker" (chunked)="mapping.chunkedData = $event" [headers]="[

		{id:'FirstName',label:'User First Name',filterable:true,sortable:true},
		{id:'LastName',label:'User Last Name',filterable:true,sortable:true},
		{idFunction:idFunctionOManagerFirstName,label:'Overridden Approver First Name',filterable:true,sortable:true},
		{idFunction:idFunctionOManagerLastName,label:'Overridden Approver Last Name',filterable:true,sortable:true},
		{id:'Comments',label:'Comments'},
		{id:'',label:''}
		]"
		  [filters]="true"
>
	<tr *ngFor="let d of mapping.chunkedData">
		<td>{{d.FirstName}}</td>
		<td>{{d.LastName}}</td>
		<td>{{d.OverridenManager.FirstName}}</td>
		<td>{{d.OverridenManager.LastName}}</td>
		<td>

			<input type="text" class="form-control " name="system_comments_{{d.id}}" placeholder="Comments" [(ngModel)]="d.OverridenManagerComments" />
            <button style =" margin-top: 5px;" mat-button class="btn-primary float-right" (click)="comments_save(d)">
                Save
            </button>
        </td>
		<td>
			<button class="btn btn-danger btn-sm" (click)="mapping_delete(d)">delete</button>
		</td>
	</tr>
</ui-table>


<div class="col-lg-6" style="    padding: 0;margin-top: 20px;">
	<div class="card">
		<div class="card-body mat-autocomplete-large">

			<mat-form-field>
				<input [formControl]="mapping.sorUserIdFormControl" type="text" placeholder="Search User" aria-label="Number" matInput [matAutocomplete]="auto">

				<mat-autocomplete panelWidth="'100%'" autoActiveFirstOption #auto="matAutocomplete" [displayWith]="autocompleteDisplayUser">
					<mat-option *ngFor="let item of  mapping.autocomplete$ | async; let index=index" [value]="item">
						{{item.FirstName}} {{item.LastName}} ({{item.Login}})
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>

			<mat-form-field>
				<input [formControl]="mapping.sorUserIdFormControlApprover" type="text" placeholder="Search new approver" aria-label="Number" matInput [matAutocomplete]="auto2">

				<mat-autocomplete panelWidth="'100%'" autoActiveFirstOption #auto2="matAutocomplete" [displayWith]="autocompleteDisplayUser">
					<mat-option *ngFor="let item of  mapping.autocompleteApprover$ | async; let index=index" [value]="item">
						{{item.FirstName}} {{item.LastName}} ({{item.Login}})
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
			<br/>
			<button class="btn btn-primary" (click)="mapping_add()">Override Approver</button>
		</div>
	</div>
</div>
